import { STATE_MAP } from './constants';
var maxState = function maxState(state1, state2) {
  return STATE_MAP[state1] > STATE_MAP[state2] ? state1 : state2;
};

/**
 * components meta information of multiple states into a "lowest" one
 * { state: 'complete' } + { state: 'loading'} = { state: 'loading' }
 */
export var composeState = function composeState() {
  var response = {
    state: 'complete',
    error: undefined
  };
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args.forEach(function (_ref) {
    var state = _ref.state,
      error = _ref.error;
    response.state = maxState(response.state, state);
    response.error = response.error || error;
  });
  return response;
};

/**
 * Response type guard, basically ensures that payload exists for the complete state so it's safe to use it
 */
export var stateGuard = function stateGuard(payload, state, error) {
  if (state === 'error') {
    return {
      payload: payload,
      state: state,
      error: error
    };
  }
  if (state === 'complete' && payload) {
    return {
      payload: payload,
      state: state,
      error: error
    };
  }
  return {
    payload: payload,
    state: 'loading',
    error: error
  };
};

// type guards

export var isLoadingState = function isLoadingState(state) {
  return state.state === 'loading';
};
export var isErrorState = function isErrorState(state) {
  return state.state === 'error';
};
export var isCompleteState = function isCompleteState(state) {
  return state.state === 'complete';
};